import { z } from "zod";
import { TransitionDto } from "./transition.ts";

export const CreativeProjectTimelineItem = z.object({
  type: z.literal("CREATIVE_PROJECT"),
  externalId: z.string(),
  startSourceImageExternalId: z.string(),
  endSourceImageExternalId: z.string().optional(),
  sourceImageExternalIds: z.array(z.string()),
  animatedImageExternalIds: z.array(z.string()),
  entryTransition: TransitionDto.optional(),
  animatedImageExternalId: z.string().optional(),
  animatedImageConfigs: z.record(
    z.string(), // animatedImageExternalId
    z.object({
      startAt: z.number(),
      duration: z.number().optional(),
      reverse: z.boolean(),
      playbackSpeed: z.number().optional(),
      volume: z.number().optional(),
      cropConfigs: z.record(
        z.string(), // aspect ratio
        z.object({
          x: z.number(),
          y: z.number(),
          width: z.number(),
          height: z.number(),
        }),
      ),
    }),
  ),
});

export type CreativeProjectTimelineItem = z.infer<
  typeof CreativeProjectTimelineItem
>;
